import type { IModuleEntityRowProps } from './IModuleEntityRowProps';

/** Рядок спроєктованої сутності модуля (прототип v4 moEnts): назва в однині (500) і опис 12px, приглушено, без переходу. */
export function ModuleEntityRow({ row }: IModuleEntityRowProps) {
  return (
    <div className="mp-erow">
      <span className="mp-erow__name">{row.name}</span>
      {row.description && <span className="mp-erow__desc">{row.description}</span>}
    </div>
  );
}
